import { Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useProfile } from '../../context/ProfileContext';
import ProfileSidebar from './ProfileSidebar';

export default function ProfileLayout() {
    const { user } = useAuth();
    const { data: fullData, isLoading } = useProfile();

    if (isLoading) {
        return (
            <div className="animate-pulse space-y-8">
                <div className="h-48 bg-white/5 rounded-2xl" />
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="lg:col-span-2 space-y-6">
                        <div className="h-64 bg-white/5 rounded-2xl" />
                    </div>
                </div>
            </div>
        );
    }

    // Fallback if data fails (should handle better but keeping simple for now)
    const profile = fullData?.profile || {
        id: 'guest',
        actively_looking: false,
        preferred_name: user?.name,
        headline: '-',
        location: '-'
    };

    return (
        <div className="animate-fade-in pb-10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                {/* Left Sidebar (Narrow) - 3 cols */}
                <div className="lg:col-span-3 space-y-6">
                    <ProfileSidebar profile={profile} email={user?.email || ''} />
                </div>

                {/* Main Content (Wide) - 9 cols */}
                <div className="lg:col-span-9 space-y-6">
                    <Outlet context={{ profile, fullData }} />
                </div>
            </div>
        </div>
    );
}
